import { Box, Typography } from '@mui/material'

export default function PermissionDeniedPage() {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Typography variant="h6">Permission Denied</Typography>
    </Box>
  )
}
